import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import VotingInfo from "../components/Filter/VotingInfo";
import DistrictInfo from "../components/Filter/DistrictInfo";
import UserInfo from "../components/Filter/UserInfo";
import VoterInfo from "../components/Filter/VoterInfo";
import ContactSearch from "../components/Filter/ContactSearch";
import WinNumberModal from "../components/WinNumberModal";
import {
  Button,
  Card,
  Grid,
  CircularProgress,
  Typography,
  Snackbar,
  Modal,
  Backdrop,
  Fade,
} from "@mui/material";
import axios from "axios";
import DataTable from "../components/TableComponent";
import Statistics from "../components/Statistics";

const Filter = () => {
  const navigate = useNavigate();
  const votingInfoRef = useRef();
  const voterInfoRef = useRef();
  const contactSearchRef = useRef();
  const [districtData, setDistrictData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [isError, setisError] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    selectedCounty: [],
    selectedPrecinct: [],
    selectedUSCongress: [],
    selectedStateSenate: [],
    selectedStateHouse: [],
    selectedMunicipality: [],
    selectedSchoolDistrict: [],
    selectedMagistrate: [],
    selectedFirstName: [],
    selectedLastName: [],
    selectedHouseNumber: [],
    selectedStreetName: [],
    selectedCity: [],
    selectedZip: [],
    selectedIDNumber: [],
    selectedHouseWith: [],
    selectedParty: [],
    selectedGender: ["Male", "Female", "Unknown"],
    selectedSupportStatus: [],
    selectedVoterStatus: ["Active"],
    selectedAge: "",
    selectedElection: [],
    selectedElectionOperator: "",
    selectedElectionsAtLeast: null,
    selectedFirstNameFilter: undefined,
    selectedLastNameFilter: undefined,
    selectedHouseNumberFilter: undefined,
    selectedStreetNameFilter: undefined,
    selectedCityFilter: undefined,
    selectedZipFilter: undefined,
    selectedEmail: { value: "", filterType: "" },
    selectedPhoneNumber: "",
  });

  const handleDistrictData = (data) => {
    setDistrictData(data);
  };

  const handleRefreshFilter = () => {
    setSelectedFilters({
      selectedCounty: [],
      selectedPrecinct: [],
      selectedUSCongress: [],
      selectedStateSenate: [],
      selectedStateHouse: [],
      selectedMunicipality: [],
      selectedSchoolDistrict: [],
      selectedMagistrate: [],
      selectedFirstName: [],
      selectedLastName: [],
      selectedHouseNumber: [],
      selectedStreetName: [],
      selectedCity: [],
      selectedZip: [],
      selectedIDNumber: [],
      selectedHouseWith: [],
      selectedParty: [],
      selectedGender: ["Male", "Female", "Unknown"],
      selectedSupportStatus: [],
      selectedVoterStatus: ["Active"],
      selectedAge: "",
      selectedElection: [],
      selectedElectionOperator: "",
      selectedElectionsAtLeast: null,
      selectedFirstNameFilter: undefined,
      selectedLastNameFilter: undefined,
      selectedHouseNumberFilter: undefined,
      selectedStreetNameFilter: undefined,
      selectedCityFilter: undefined,
      selectedZipFilter: undefined,
      selectedEmail: { value: "", filterType: "" },
      selectedPhoneNumber: "",
    });

    // Reset child component states
    if (votingInfoRef.current) {
      votingInfoRef.current.handleRefreshFilter();
    }
    if (voterInfoRef.current) {
      voterInfoRef.current.handleRefreshFilter();
    }
    if (contactSearchRef.current) {
      contactSearchRef.current.handleRefreshFilter();
    }

    setDistrictData([]);
    setLoading(false);
  };
  
  const handleClearStatus = () => {
    setClearStatusDialogOpen(true);
  };

  const handleClearStatusDialogClose = () => {
    setClearStatusDialogOpen(false);
    setClearConfirmText("");
  };

  const handleConfirmClearAllStatuses = async () => {
    if (clearConfirmText !== "clear") {
      return;
    }

    setClearStatusLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/reset_all_support_statuses`,
        {},
        { timeout: 60000 } // 60 second timeout
      );
      setisError(true);
      setErrorMessage("All support statuses cleared successfully");
      setTimeout(() => setisError(false), 5000);
      handleClearStatusDialogClose();
    } catch (error) {
      setisError(true);
      setErrorMessage("Failed to clear support statuses. Please try again.");
      setTimeout(() => setisError(false), 3000);
      console.error("Error clearing support statuses:", error);
    } finally {
      setClearStatusLoading(false);
    }
  };
  
  const [loading, setLoading] = useState(false);
  const [countData, setCountData] = useState({});
  const handleSubmit = async () => {
    try {
      setLoading(true);
      const renamedFilters = {
        County: selectedFilters.selectedCounty,
        Precinct_Name: selectedFilters.selectedPrecinct,
        "U.S._Congress": selectedFilters.selectedUSCongress,
        State_Senate: selectedFilters.selectedStateSenate,
        State_House: selectedFilters.selectedStateHouse,
        Municipality: selectedFilters.selectedMunicipality,
        School_District: selectedFilters.selectedSchoolDistrict,
        Magistrate: selectedFilters.selectedMagistrate,
        First_Name: selectedFilters.selectedFirstName,
        Last_Name: selectedFilters.selectedLastName,
        House_Number: selectedFilters.selectedHouseNumber,
        City: selectedFilters.selectedCity,
        Street_Name: selectedFilters.selectedStreetName,
        Zip: selectedFilters.selectedZip,
        ID_Number: selectedFilters.selectedIDNumber,
        Party_Code: selectedFilters.selectedParty,
        Gender: selectedFilters.selectedGender,
        Age: selectedFilters.selectedAge,
        Voter_Status: selectedFilters.selectedVoterStatus,
        Election: selectedFilters.selectedElection,
        Status: selectedFilters.selectedSupportStatus,
        HouseWith: selectedFilters.selectedHouseWith,
        Email: selectedFilters.selectedEmail,
        Phone_Number: selectedFilters.selectedPhoneNumber,
        Election_Operator: selectedFilters.selectedElectionOperator,
        ...(selectedFilters.selectedElectionOperator === "At Least" && selectedFilters.selectedElectionsAtLeast
          ? { Election_Operator_N: selectedFilters.selectedElectionsAtLeast }
          : {}),
      };

      console.log(renamedFilters);
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/search`,
        renamedFilters
      );

      setTotalCount(response.data.count);

      const rowsWithId = response.data.data.map((row, index) => ({
        ...row,
        id: row.ID_Number,
      }));

      // Limit to 5000 records
      const limitedData = rowsWithId.slice(0, 5000);
      setDistrictData(limitedData);
    } catch (error) {
      setisError(true);
      setErrorMessage("Somthing went wrong please try again");
      setisError(false);
      console.error("Error fetching district data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleExport = () => {
    try {
      const renamedFilters = {
        County: selectedFilters.selectedCounty,
        Precinct_Name: selectedFilters.selectedPrecinct,
        "U.S._Congress": selectedFilters.selectedUSCongress,
        State_Senate: selectedFilters.selectedStateSenate,
        State_House: selectedFilters.selectedStateHouse,
        Municipality: selectedFilters.selectedMunicipality,
        School_District: selectedFilters.selectedSchoolDistrict,
        Magistrate: selectedFilters.selectedMagistrate,
        First_Name: selectedFilters.selectedFirstName,
        Last_Name: selectedFilters.selectedLastName,
        House_Number: selectedFilters.selectedHouseNumber,
        City: selectedFilters.selectedCity,
        Street_Name: selectedFilters.selectedStreetName,
        Zip: selectedFilters.selectedZip,
        ID_Number: selectedFilters.selectedIDNumber,
        Party_Code: selectedFilters.selectedParty,
        Gender: selectedFilters.selectedGender,
        Age: selectedFilters.selectedAge,
        Voter_Status: selectedFilters.selectedVoterStatus,
        Election: selectedFilters.selectedElection,
        Status: selectedFilters.selectedSupportStatus,
        HouseWith: selectedFilters.selectedHouseWith,
        Email: selectedFilters.selectedEmail,
        Phone_Number: selectedFilters.selectedPhoneNumber,
        Election_Operator: selectedFilters.selectedElectionOperator,
        ...(selectedFilters.selectedElectionOperator === "At Least" && selectedFilters.selectedElectionsAtLeast
          ? { Election_Operator_N: selectedFilters.selectedElectionsAtLeast }
          : {}),
      };

      console.log(renamedFilters);
      navigate("/export", { state: { exportData: renamedFilters } });
    } catch (error) {
      setisError(true);
      setErrorMessage("Somthing went wrong please try again");
      setisError(false);
      console.error("Error fetching district data:", error);
    }
  };

  const isDistrictFilterApplied = () => {
    return (
      selectedFilters.selectedCounty.length > 0 ||
      selectedFilters.selectedPrecinct.length > 0 ||
      selectedFilters.selectedUSCongress.length > 0 ||
      selectedFilters.selectedStateSenate.length > 0 ||
      selectedFilters.selectedStateHouse.length > 0 ||
      selectedFilters.selectedMunicipality.length > 0 ||
      selectedFilters.selectedSchoolDistrict.length > 0 ||
      selectedFilters.selectedMagistrate.length > 0
    );
  };

  const getSmallestDistrictLevel = () => {
    // Priority order: index 0 = smallest (most granular), last = biggest
    const priority = [
      { key: 'selectedPrecinct',      field: 'Precinct_Name' },
      { key: 'selectedMagistrate',    field: 'Magistrate' },
      { key: 'selectedSchoolDistrict',field: 'School_District' },
      { key: 'selectedStateHouse',    field: 'State_House' },
      { key: 'selectedStateSenate',   field: 'State_Senate' },
      { key: 'selectedMunicipality',  field: 'Municipality' },
      { key: 'selectedUSCongress',    field: 'U.S._Congress' },
      { key: 'selectedCounty',        field: 'County' },
    ];
    for (const { key, field } of priority) {
      const val = selectedFilters[key];
      if (Array.isArray(val) && val.length > 0) return { field, values: val };
      if (val && !Array.isArray(val)) return { field, values: [val] };
    }
    return null;
  };

  const handleWinNumber = () => {
    setWinNumberModalOpen(true);
  };

  const [open, setOpen] = useState(false);
  const [counts, setCounts] = useState(null);
  const [countLoading, setCountLoading] = useState(false);
  const [clearStatusDialogOpen, setClearStatusDialogOpen] = useState(false);
  const [clearConfirmText, setClearConfirmText] = useState("");
  const [clearStatusLoading, setClearStatusLoading] = useState(false);
  const [winNumberModalOpen, setWinNumberModalOpen] = useState(false);

  const handleCount = async () => {
    setCountLoading(true);
    try {
      const renamedFilters = {
        County: selectedFilters.selectedCounty,
        Precinct_Name: selectedFilters.selectedPrecinct,
        "U.S._Congress": selectedFilters.selectedUSCongress,
        State_Senate: selectedFilters.selectedStateSenate,
        State_House: selectedFilters.selectedStateHouse,
        Municipality: selectedFilters.selectedMunicipality,
        School_District: selectedFilters.selectedSchoolDistrict,
        Magistrate: selectedFilters.selectedMagistrate,
        First_Name: selectedFilters.selectedFirstName,
        Last_Name: selectedFilters.selectedLastName,
        House_Number: selectedFilters.selectedHouseNumber,
        City: selectedFilters.selectedCity,
        Street_Name: selectedFilters.selectedStreetName,
        Zip: selectedFilters.selectedZip,
        ID_Number: selectedFilters.selectedIDNumber,
        Party_Code: selectedFilters.selectedParty,
        Gender: selectedFilters.selectedGender,
        Age: selectedFilters.selectedAge,
        Voter_Status: selectedFilters.selectedVoterStatus,
        Election: selectedFilters.selectedElection,
        Status: selectedFilters.selectedSupportStatus,
        HouseWith: selectedFilters.selectedHouseWith,
        Email: selectedFilters.selectedEmail,
        Phone_Number: selectedFilters.selectedPhoneNumber,
        Election_Operator: selectedFilters.selectedElectionOperator,
        ...(selectedFilters.selectedElectionOperator === "At Least" && selectedFilters.selectedElectionsAtLeast
          ? { Election_Operator_N: selectedFilters.selectedElectionsAtLeast }
          : {}),
      };

      console.log(renamedFilters);
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/count`,
        renamedFilters
      );
      console.log(response);
      const data = response.data;
      const totalGenderCount = Object.values(data.gender_count).reduce(
        (total, count) => total + count,
        0
      );

      data.total_count = totalGenderCount;
      setCounts(data);

      setOpen(true);
    } catch (e) {
      console.log(e);
    } finally {
      setCountLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <div className="flex flex-col md:flex-row">
        <Snackbar
          open={isError}
          onClose={() => setisError(false)}
          style={{ backgroundColor: "red", color: "white" }}
          autoHideDuration={2000}
          message={errorMessage}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        />
        <WinNumberModal
          open={winNumberModalOpen}
          onClose={() => setWinNumberModalOpen(false)}
          districtInfo={getSmallestDistrictLevel()}
        />
        <div className="flex-1">
          <DistrictInfo
            onDistrictData={handleDistrictData}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
          <VoterInfo
            ref={voterInfoRef}
            onDistrictData={handleDistrictData}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
          <ContactSearch
            ref={contactSearchRef}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
        </div>
        <div className="flex-1">
          <VotingInfo
            ref={votingInfoRef}
            onDistrictData={handleDistrictData}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
          <UserInfo
            onDistrictData={handleDistrictData}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />
        </div>
      </div>
      <Card elevation={3} className="m-2 sm:m-4 p-4">
        {/* Desktop View */}
        <div className="hidden md:flex justify-between">
          <div>
            <Button variant="outlined" onClick={handleRefreshFilter}>
              REFRESH FILTERS
            </Button>
            <i className="px-2" />
            <Button variant="outlined" onClick={handleClearStatus} sx={{ color: 'red', borderColor: 'red' }}>
              CLEAR STATUS
            </Button>
          </div>
          <div>
            <Button variant="contained" onClick={handleSubmit}>
              SUBMIT
            </Button>
            <i className="px-2" />
            <Button variant="outlined" onClick={handleCount}>
              {countLoading ? "Counting..." : "COUNT"}
            </Button>
            <i className="px-2" />
            <Button variant="outlined" onClick={handleExport}>
              EXPORT
            </Button>
            <i className="px-2" />
            <Button 
              variant="outlined" 
              onClick={handleWinNumber}
              disabled={!isDistrictFilterApplied()}
            >
              WIN NUMBER
            </Button>
          </div>
        </div>
        
        {/* Mobile View */}
        <div className="flex md:hidden flex-col gap-2">
          <div className="flex gap-2">
            <Button variant="outlined" onClick={handleRefreshFilter} sx={{ flex: 1 }}>
              REFRESH FILTERS
            </Button>
            <Button variant="outlined" onClick={handleClearStatus} sx={{ flex: 1, color: 'red', borderColor: 'red' }}>
              CLEAR STATUS
            </Button>
          </div>
          <div className="flex gap-2">
            <Button variant="contained" onClick={handleSubmit} sx={{ flex: 1 }}>
              SUBMIT
            </Button>
            <Button variant="outlined" onClick={handleCount} sx={{ flex: 1 }}>
              {countLoading ? "COUNTING..." : "COUNT"}
            </Button>
          </div>
          <div className="flex gap-2">
            <Button variant="outlined" onClick={handleExport} sx={{ flex: 1 }}>
              EXPORT
            </Button>
            <Button 
              variant="outlined" 
              onClick={handleWinNumber}
              disabled={!isDistrictFilterApplied()}
              sx={{ flex: 1 }}
            >
              WIN NUMBER
            </Button>
          </div>
        </div>
        <Modal
          open={clearStatusDialogOpen}
          onClose={handleClearStatusDialogClose}
          aria-labelledby="clear-status-modal-title"
          aria-describedby="clear-status-modal-description"
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={clearStatusDialogOpen}>
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4">
              <div className="bg-white p-6 rounded-md w-full max-w-md">
                <h2
                  id="clear-status-modal-title"
                  className="text-2xl font-bold mb-4 text-red-600"
                >
                  Clear All Support Statuses
                </h2>
                <div id="clear-status-modal-description">
                  <p className="mb-4 text-gray-700">
                    This will clear all support statuses across the entire system.
                    This action cannot be undone.
                  </p>
                  <p className="mb-4 font-semibold">
                    Type "clear" to confirm:
                  </p>
                  <input
                    type="text"
                    value={clearConfirmText}
                    onChange={(e) => setClearConfirmText(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 mb-4"
                    placeholder="Type 'clear' here"
                  />
                </div>
                <div className="flex gap-2">
                  <Button
                    variant="outlined"
                    onClick={handleClearStatusDialogClose}
                    className="flex-1"
                    disabled={clearStatusLoading}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleConfirmClearAllStatuses}
                    className="flex-1"
                    disabled={clearConfirmText !== "clear" || clearStatusLoading}
                    sx={{
                      bgcolor: clearConfirmText === "clear" ? "#dc2626" : undefined,
                      "&:hover": {
                        bgcolor: clearConfirmText === "clear" ? "#b91c1c" : undefined,
                      },
                    }}
                  >
                    {clearStatusLoading ? "Clearing..." : "Confirm"}
                  </Button>
                </div>
              </div>
            </div>
          </Fade>
        </Modal>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4">
              <div className="bg-white p-6 rounded-md w-full max-w-md max-h-[90vh] overflow-y-auto">
                <h2
                  id="transition-modal-title"
                  className="text-2xl font-bold mb-4"
                >
                  Counts
                </h2>
                <div id="transition-modal-description">
                  {counts && (
                    <>
                      <p className="mb-2">
                        <span className="font-semibold">Total Registered Voters:</span>{" "}
                        {counts?.total_registered_voters?.toLocaleString() || "N/A"}
                      </p>
                      <p className="mb-2">
                        <span className="font-semibold">Total Count:</span>{" "}
                        {counts?.total_count.toLocaleString()}
                      </p>
                      <p className="mb-2">
                        <span className="font-semibold">City Count:</span>{" "}
                        {counts.city_count.toLocaleString()}
                      </p>

                      <p className="mb-2">
                        <span className="font-semibold">
                          Phone Number Count:
                        </span>{" "}
                        {counts.homephone_count.toLocaleString()}
                      </p>
                      <p className="mb-2">
                        <span className="font-semibold">Gender Count:</span>{" "}
                        {Object.entries(counts.gender_count).map(
                          ([gender, count]) => (
                            <p key={gender} className="ml-2">
                              <span className="font-semibold">{gender}</span>:{" "}
                              {count.toLocaleString()}
                            </p>
                          )
                        )}
                      </p>
                      <p className="mb-2">
                        <span className="font-semibold">Party Count:</span>{" "}
                        {Object.entries(counts.party_count).map(
                          ([party, count]) => (
                            <p key={party} className="ml-2">
                              {party !== "At Polls" && (
                                <>
                                  <span className="font-semibold">{party}</span>
                                  : {count.toLocaleString()}
                                </>
                              )}
                            </p>
                          )
                        )}
                      </p>
                      {counts.unique_address < 10000 && (
                        <p className="mb-2">
                          <span className="font-semibold">
                            Unique Address Count:
                          </span>{" "}
                          {counts.unique_address.toLocaleString()}
                        </p>
                      )}
                    </>
                  )}
                </div>

                <Button
                  variant="outlined"
                  className="mt-4 w-full"
                  onClick={handleClose}
                >
                  Close
                </Button>
              </div>
            </div>
          </Fade>
        </Modal>
        {/* {loading && (
          <CircularProgress
            size={24}
            style={{ marginLeft: 10, color: "green" }}
          />
        )} */}
      </Card>
      {loading ? (
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <CircularProgress />
          <Typography variant="body2" color="textSecondary" component="p">
            Loading district data...
          </Typography>
        </div>
      ) : (
        <>
          {districtData.length >= 1 ? (
            <div>
              <Statistics data={districtData} totalCount={totalCount} />
              <div className="p-4">
                {districtData.length >= 5000 ? (
                  <p className="py-2 px-2 text-xs md:text-sm bg-red-500 text-white rounded">
                    Warning: Your results exceeded 5,000 records, we are only
                    showing the first 5,000
                  </p>
                ) : (
                  <></>
                )}
                <DataTable data={districtData} />
              </div>
            </div>
          ) : (
            <>No Result</>
          )}
        </>
      )}
    </div>
  );
};

export default Filter;
